export enum RegistrationType {
    Login,
    Logout,
    Labour,
    StartPause,
    EndPause,
}
